import useTracker from '@hooks/useTracker';
import { CLICK_MF_DETAIL } from '@services/trackerConst';

const useEventTracker = () => {
  const { trackEvent } = useTracker();

  const eventClickMfDetail = (props) => {
    trackEvent(CLICK_MF_DETAIL, props);
  };

  return {
    eventClickMfDetail,
  };
};

export default useEventTracker;
